import styled from "styled-components";
import {Form} from "formik";

export const FormWrapper = styled(Form)`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
`;